/* eslint-disable react-refresh/only-export-components */
// Imports React and ReactDOM
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Imports CSS
import './globals.css';

// Imports thirt-party
import { router } from './pages/router';

function App() {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
